const {loadScript, loadStyle} = require('./util/loadDependencies');

var modaal_posts_loaded = [];

export default (jsBasePath) => jQuery(($) => {
	const triggerLightbox = () => {
		$('.lightbox_inline').each(function () {
			var this_post_ajax_url = $(this).attr('data-modaal-ajax-url');
			var post_id = $(this).attr('data-post-id');
			var lazy_load_content_div = $('#lightbox_post_' + post_id);
			var lazy_load_content_target = $('#lightbox_post_' + post_id + '_expanded');

			$(this).modaal({
				type: 'inline',
				content_source: lazy_load_content_div,
				before_open: () => {
					if ($.inArray(post_id, modaal_posts_loaded) === -1) {
						$.get(this_post_ajax_url, function (data) {
							lazy_load_content_target.html(data.data);
						});
						modaal_posts_loaded.push(post_id);
					}
				}
			});
		});
	};

	$('.modaal-prev-next')
		.click(function (e) {
			e.preventDefault();

			$('.lightbox_inline[data-post-id="' + $(this)
				.attr('data-modaal-close-id') + '"]')
				.modaal('close');
			$('.lightbox_inline[data-post-id="' + $(this)
				.attr('data-modaal-open-id') + '"]')
				.modaal('open');
		});

	$(document)
		.keyup(function (e) {
			e.preventDefault();

			if ($('.modaal-wrapper .modaal-content.modaal-focus .modaal-prev-next').length) {
				var key = e.which;
				var prev = $('.modaal-wrapper .modaal-content.modaal-focus .modaal-prev-next.modaal-prev');
				var next = $('.modaal-wrapper .modaal-content.modaal-focus .modaal-prev-next.modaal-next');
				// arrow left for back
				if (key == 37 && prev.length) {
					prev.click();
					return;
				}
				// arrow right for next
				if (key == 39 && next.length) {
					next.click();
					return;
				}
			}
		});

	loadStyle(`${jsBasePath}../vendor/modaal/css/modaal.min.css`);
	loadScript(`${jsBasePath}../vendor/modaal/js/modaal.min.js`, triggerLightbox);
});
